import { useMutation } from 'react-query'
import { getErrorString, isObjectWithKey } from 'src/utils'
import {
  attachIAMPolicy,
  createFullUserpool,
  createIAMPolicy,
  createIAMUser,
  testSetup,
  resyncSubscriptionProvisioning,
} from './api'
import { toast } from 'sonner'

export function useCreateIAMUser() {
  return useMutation(createIAMUser, {
    onError: (error) => {
      toast.error(getErrorString(error))
    },
  })
}

export function useCreateIAMPolicy() {
  return useMutation(createIAMPolicy, {
    onError: (error) => {
      toast.error(getErrorString(error))
    },
  })
}

export function useAttachIAMPolicy() {
  return useMutation(attachIAMPolicy, {
    onError: (error) => {
      toast.error(getErrorString(error))
    },
  })
}

export function useTestSetup() {
  return useMutation(testSetup, {
    onError: (error) => {
      if (
        isObjectWithKey(error, 'reason') &&
        typeof error.reason === 'string' &&
        error.reason.startsWith('unable to createUser() for')
      ) {
        toast.error(
          `Still busy setting up organization, please try again in a couple of minutes.`,
        )
      } else {
        toast.error(getErrorString(error))
      }
    },
  })
}

export function useCreateFullUserPool() {
  return useMutation(createFullUserpool)
}

export function useResyncSubscriptionProvisioning() {
  return useMutation(resyncSubscriptionProvisioning)
}
